import { CashSummaryDTO } from '../../../dto/locationcash/LocationCashDTO';

interface CashSummaryCardsProps {
    summary: CashSummaryDTO;
}

function formatMoney(amount: number | null | undefined): string {
    if (amount == null) return '—';
    return `$ ${amount.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

interface SummaryCardProps {
    title: string;
    amount: number;
    icon: string;
    highlight?: boolean;
}

function SummaryCard({ title, amount, icon, highlight }: SummaryCardProps) {
    return (
        <div className={`cash-summary-card ${highlight ? 'cash-summary-card--highlight' : ''}`}>
            <div className="cash-summary-card__header">
                <i className={`pi ${icon}`} />
                <span>{title}</span>
            </div>
            <span className="cash-summary-card__amount">
                {formatMoney(amount)}
            </span>
        </div>
    );
}

export default function CashSummaryCards({ summary }: CashSummaryCardsProps) {
    return (
        <div className="cash-summary-grid">
            <SummaryCard
                title="Total en caja"
                amount={summary.totalAmount}
                icon="pi-wallet"
                highlight
            />
            <SummaryCard
                title="Sesión actual"
                amount={summary.sessionAmount}
                icon="pi-clock"
            />
            <SummaryCard
                title="Coseguros"
                amount={summary.copaymentAmount}
                icon="pi-shield"
            />
            <SummaryCard
                title="Diferenciales"
                amount={summary.diferentialAmount}
                icon="pi-chart-bar"
            />
            <SummaryCard
                title="Particulares"
                amount={summary.particularAmount}
                icon="pi-user"
            />
            <SummaryCard
                title="Salidas por rendición"
                amount={summary.professionalPaymentAmount}
                icon="pi-sign-out"
            />
        </div>
    );
}
